(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1471],{

/***/ 40261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"modal-container--a1f1e","modalContainer":"modal-container--a1f1e"};

/***/ }),

/***/ 42092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ ModalPortal; },
  "d": function() { return /* binding */ ModalPortalProvider; }
});

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(35964);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(61820);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/symbol.js
var symbol = __webpack_require__(15446);
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useRefForContext.js



/**
 * Creates a ref object that triggers a re-render when ref changes
 *
 * This is useful to pass a ref via context and have consumers re-render when
 * element becomes available
 */
const $nextRef = symbol_default()('next-ref');
const useRefForContext = function () {
  let initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  const [ref, setRef] = react.useState(initial);
  return react.useMemo(() => ({
    [$nextRef]: null,
    get current() {
      return this[$nextRef] || ref;
    },
    set current(nextRef) {
      this[$nextRef] = nextRef;
      setRef(nextRef);
    }
  }), [ref]);
};
/* harmony default export */ var utils_useRefForContext = (useRefForContext);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/globals.js
var globals = __webpack_require__(39085);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalPortal/index.js





const ModalPortalProvider = _ref => {
  let {
    children
  } = _ref;
  const ref = utils_useRefForContext();
  return /*#__PURE__*/react.createElement(globals/* ModalPortalRefContext.Provider */.i4.Provider, {
    value: ref
  }, children(ref));
};
 false ? 0 : void 0;

/**
 * Renders its children inside of the modal container created by `LayoutRoot`
 */
const ModalPortal = _ref2 => {
  let {
    children
  } = _ref2;
  const ref = react.useContext(globals/* ModalPortalRefContext */.i4);

  // If layout is not preset, just render modal
  if (!ref) {
    return children;
  }

  // Layout is present but portal container hasn't mounted yet
  if (!ref.current) {
    return null;
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react_dom.createPortal(children, ref.current));
};
ModalPortal.propTypes = {
  children: (prop_types_default()).node
};


/***/ }),

/***/ 61963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ createActiveBranchStack; },
/* harmony export */   "g": function() { return /* binding */ createRegisterNode; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84596);
/* harmony import */ var _babel_runtime_corejs3_core_js_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39015);
/* harmony import */ var _babel_runtime_corejs3_core_js_set__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_set__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17843);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_values__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_values__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_at__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59321);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_at__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_at__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75957);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_define_properties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26482);
/* harmony import */ var _babel_runtime_corejs3_core_js_object_define_properties__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_object_define_properties__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48492);
/* harmony import */ var _babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_5__);







function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
var _items = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_5___default())();
var _eventTarget = /*#__PURE__*/new (_babel_runtime_corejs3_core_js_weak_map__WEBPACK_IMPORTED_MODULE_5___default())();
/**
 * Reactive Queue - a queue that emits an event when it changes
 */
class ReactiveQueue {
  constructor() {
    _classPrivateFieldInitSpec(this, _items, {
      writable: true,
      value: new (_babel_runtime_corejs3_core_js_set__WEBPACK_IMPORTED_MODULE_0___default())()
    });
    _classPrivateFieldInitSpec(this, _eventTarget, {
      writable: true,
      value: new EventTarget()
    });
  }
  get size() {
    return (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).size;
  }
  has(item) {
    return (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).has(item);
  }
  push(item) {
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).add(item);
    this.emitChange();
  }
  delete(item) {
    if (!(0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).has(item)) {
      return;
    }
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).delete(item);
    this.emitChange();
  }
  peek() {
    var _context;
    if ((0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items).size === 0) {
      return undefined;
    }
    return _babel_runtime_corejs3_core_js_instance_values__WEBPACK_IMPORTED_MODULE_1___default()(_context = (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _items)).call(_context).next().value;
  }
  emitChange() {
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _eventTarget).dispatchEvent(new CustomEvent('change'));
  }
  addEventListener() {
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _eventTarget).addEventListener(...arguments);
  }
  removeEventListener() {
    (0,_babel_runtime_corejs3_helpers_esm_classPrivateFieldGet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, _eventTarget).removeEventListener(...arguments);
  }
}
/**
 * Exposes a stack to inspect the "active" branch of the register tree.
 */
const createActiveBranchStack = rootRegisterNode => {
  var _context2, _context3;
  let stackArray = [rootRegisterNode];
  const stackSet = new (_babel_runtime_corejs3_core_js_set__WEBPACK_IMPORTED_MODULE_0___default())(stackArray);
  const eventTarget = new EventTarget();
  const regenerateStack = () => {
    stackSet.clear();
    stackArray = [];
    let current = rootRegisterNode;
    while (current) {
      stackArray.push(current);
      stackSet.add(current);
      current = current.peek();
    }
    eventTarget.dispatchEvent(new CustomEvent('change'));
  };
  const stack = {
    get items() {
      return stackArray;
    },
    get size() {
      return stackArray.length;
    },
    has: item => stackSet.has(item),
    peek: () => _babel_runtime_corejs3_core_js_instance_at__WEBPACK_IMPORTED_MODULE_2___default()(stackArray).call(stackArray, -1),
    mount: () => {
      rootRegisterNode.addEventListener('change', regenerateStack);
    },
    unmount: () => {
      rootRegisterNode.removeEventListener('change', regenerateStack);
    },
    addEventListener: _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3___default()(_context2 = eventTarget.addEventListener).call(_context2, eventTarget),
    removeEventListener: _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3___default()(_context3 = eventTarget.removeEventListener).call(_context3, eventTarget)
  };
  return stack;
};
let id = 0;
const withDebuggingProperties = (obj, queue) => _babel_runtime_corejs3_core_js_object_define_properties__WEBPACK_IMPORTED_MODULE_4___default()(obj, {
  id: {
    // eslint-disable-next-line no-plusplus
    value: id++
  },
  queue: {
    value: queue
  },
  // API to behave like a react ref that can be used
  // to easily store HTML elements
  current: {
    writable: true,
    value: null
  }
});
const createRegisterNode = () => {
  var _context4, _context5;
  const queue = new ReactiveQueue();
  const forwardChangeToParent = () => {
    queue.emitChange();
  };
  const addEventListener = _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3___default()(_context4 = queue.addEventListener).call(_context4, queue);
  const removeEventListener = _babel_runtime_corejs3_core_js_instance_bind__WEBPACK_IMPORTED_MODULE_3___default()(_context5 = queue.removeEventListener).call(_context5, queue);
  return withDebuggingProperties({
    addEventListener,
    removeEventListener,
    has: item => queue.has(item),
    peek: () => queue.peek(),
    get size() {
      return queue.size;
    },
    addChild: item => {
      if (queue.has(item)) {
        return;
      }
      queue.push(item);
      item.addEventListener('change', forwardChangeToParent);
    },
    removeChild: item => {
      queue.delete(item);
      item.removeEventListener('change', forwardChangeToParent);
    }
  }, queue);
};

/***/ }),

/***/ 91167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zk": function() { return /* binding */ ModalRegister; },
  "_$": function() { return /* binding */ useModalRegister; },
  "Pt": function() { return /* binding */ useModalRootRegisterNode; }
});

// UNUSED EXPORTS: useModalIsActive, useModalLevel, useModalRegisterInit

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(21818);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalRegister/RegisterTree.js
var RegisterTree = __webpack_require__(61963);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useConstant.js


/**
 * Use an unchanging value across renders.
 */
const useConstant = build => {
  const ref = react.useRef();
  if (!ref.current) {
    ref.current = build();
  }
  return ref.current;
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useIsControlled.js


/**
 * check if a value is controlled by the caller. The result does not change
 * accross renders. Once a value is controlled, it should stay as controlled.
 */
const useIsControlled = value => {
  const isControlled = react.useRef(value !== undefined).current;
  const lastIsControlled = value !== undefined;
  if (lastIsControlled !== isControlled) {
     false ? 0 : void 0;
  }
  return isControlled;
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useOptionallyControlledHook.js


/**
 * Hook that returns a controlled value if it is controlled, otherwise
 * it creates a new value using the provided hook factory.
 */
const useOptionallyControlledHook = function (hookResult, hookFactory) {
  const isControlled = useIsControlled(hookResult);
  if (isControlled) {
    return hookResult;
  }
  for (var _len = arguments.length, hookFactoryArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    hookFactoryArgs[_key - 2] = arguments[_key];
  }
  return hookFactory(...hookFactoryArgs);
};
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/globals.js
var globals = __webpack_require__(39085);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useGlobalEffect.js


/**
 * Hook that runs an effect once globally even if mounted multiple times
 * by multiple components.
 *
 * Requires that the `globalEffect` variable be a stable reference.
 */
const useGlobalEffect = globalEffect => {
  react.useEffect(() => {
    const incrementedCount = (globals/* globalEffectsCounterMap.get */.Cr.get(globalEffect) || 0) + 1;
    globals/* globalEffectsCounterMap.set */.Cr.set(globalEffect, incrementedCount);
    if (incrementedCount === 1) {
      const teardown = globalEffect();
      globals/* globalEffectsTeardownMap.set */.a8.set(globalEffect, teardown);
    }
    return () => {
      const decrementedCount = globals/* globalEffectsCounterMap.get */.Cr.get(globalEffect) - 1;
      globals/* globalEffectsCounterMap.set */.Cr.set(globalEffect, decrementedCount);
      if (decrementedCount === 0) {
        const teardown = globals/* globalEffectsTeardownMap.get */.a8.get(globalEffect);
        globals/* globalEffectsCounterMap.delete */.Cr["delete"](globalEffect);
        globals/* globalEffectsTeardownMap.delete */.a8["delete"](globalEffect);
        if (teardown) {
          teardown();
        }
      }
    };
  }, []);
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useForceRender.js


/**
 * Get a function that wil force a component to re-render.
 */
const useForceRender = () => {
  const [, setCount] = react.useState(0);
  return react.useCallback(() => {
    setCount(count => (count + 1) % 1000000);
  }, []);
};
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/utils/useEventTargetSubscription.js


/**
 * Utility that subscribes to events and forces a rerender
 *
 * downstream consumers must track the properties that will change
 * as the event target object itself doesnt change.
 */
const useEventTargetSubscription = (target, eventName) => {
  const forceRender = useForceRender();
  react.useEffect(() => {
    target.addEventListener(eventName, forceRender);
    return () => {
      target.removeEventListener(eventName, forceRender);
    };
  }, []);
  return target;
};
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalRegister/styles.css
var styles = __webpack_require__(40261);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ModalRegister/index.js









const useModalRootRegisterNode = () => useEventTargetSubscription(globals/* rootRegisterNode */.KH, 'change');
const useActiveRegisterStack = () => {
  useGlobalEffect(globals/* activeBranchStackInitEffect */.LN);
  return useEventTargetSubscription(globals/* activeBranchStack */.mp, 'change');
};

/**
 * Use nearest ModalRegister
 */
const useModalRegister = () => react.useContext(globals/* ModalRegisterTreeContext */.mm);
const useModalRegisterInit = _ref => {
  let {
    enabled = true,
    parent: controlledParent
  } = _ref;
  const parent = useOptionallyControlledHook(controlledParent, useModalRegister);
  const activeRegisterStack = useActiveRegisterStack();
  const registerNode = useConstant(RegisterTree/* createRegisterNode */.g);
  const activeBranchTop = activeRegisterStack.peek();
  const isVisible = activeRegisterStack.has(registerNode);
  const isActive = activeBranchTop === registerNode;
  const level = parent.level + 1;
  const state = react.useMemo(() => ({
    level,
    isActive,
    isVisible
  }), [level, isActive, isVisible]);
  react.useEffect(() => {
    if (enabled) {
      parent.registerNode.addChild(registerNode);
      return () => {
        parent.registerNode.removeChild(registerNode);
      };
    }
    return (noop_default());
  }, [enabled]);
  const register = react.useMemo(() => ({
    ...state,
    registerNode
  }), [state, registerNode]);
  return register;
};
/**
 * Component that creates a modal register
 *
 * All modal components must be wrapped in a ModalRegister to properly
 * manage modal visibility.
 *
 * Supports nesting modals and queing neighboring modals
 */
const ModalRegister = _ref2 => {
  let {
    enabled = true,
    parentRegister,
    register,
    children
  } = _ref2;
  const thisRegister = useOptionallyControlledHook(register, useModalRegisterInit, {
    enabled,
    parent: parentRegister
  });
  const defaultContainerProps = {
    className: (styles_default())["modal-container"],
    style: {
      '--union-modal-level': thisRegister.level,
      '--union-modal-visibility': thisRegister.isVisible ? 'visible' : 'hidden'
    }
  };
  return /*#__PURE__*/react.createElement(globals/* ModalRegisterTreeContext.Provider */.mm.Provider, {
    value: thisRegister
  }, typeof children === 'function' ? children(thisRegister, defaultContainerProps) : children);
};

/**
 * Use the level of the nearest ModalRegister
 */
const useModalLevel = () => {
  const {
    level
  } = useModalRegister();
  return level;
};

/**
 * Use the active state of the nearsed ModalRegister
 */
const useModalIsActive = () => {
  const {
    isActive
  } = useModalRegister();
  return isActive;
};

/***/ }),

/***/ 39085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cr": function() { return /* binding */ globalEffectsCounterMap; },
/* harmony export */   "KH": function() { return /* binding */ rootRegisterNode; },
/* harmony export */   "LN": function() { return /* binding */ activeBranchStackInitEffect; },
/* harmony export */   "a8": function() { return /* binding */ globalEffectsTeardownMap; },
/* harmony export */   "i4": function() { return /* binding */ ModalPortalRefContext; },
/* harmony export */   "mm": function() { return /* binding */ ModalRegisterTreeContext; },
/* harmony export */   "mp": function() { return /* binding */ activeBranchStack; }
/* harmony export */ });
/* unused harmony export rootRegister */
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol_for__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57621);
/* harmony import */ var _babel_runtime_corejs3_core_js_symbol_for__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_symbol_for__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12644);
/* harmony import */ var _babel_runtime_corejs3_core_js_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26111);
/* harmony import */ var _babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99084);
/* harmony import */ var _ModalRegister_RegisterTree_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61963);



/**
 * @module
 *
 * These are globals that are used by the ModalRegister.
 * these are globals to avoid needing to make this package
 * a peer-dependency (a singleton in a bundle).
 * Thus allowing multiple versions of this package to be present in
 * a bundle without causing issues.
 *
 * The need for globals will go away once we implement the `app-kernel`
 * in the Union Evolution project.
 */


const packageGlobals = _babel_runtime_corejs3_core_js_symbol_for__WEBPACK_IMPORTED_MODULE_0___default()('@xo-union/ui-accessibility-globals');
const initGlobals = () => {
  const rootRegisterNode = (0,_ModalRegister_RegisterTree_js__WEBPACK_IMPORTED_MODULE_4__/* .createRegisterNode */ .g)();
  const activeBranchStack = (0,_ModalRegister_RegisterTree_js__WEBPACK_IMPORTED_MODULE_4__/* .createActiveBranchStack */ .E)(rootRegisterNode);
  const rootRegister = {
    level: 0,
    isActive: false,
    isVisible: true,
    registerNode: rootRegisterNode
  };
  const activeBranchStackInitEffect = () => {
    activeBranchStack.mount();
    return () => activeBranchStack.unmount();
  };
  const ModalRegisterTreeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createContext(rootRegister);
  const ModalPortalRefContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createContext(null);
  const globalEffectsCounterMap = new (_babel_runtime_corejs3_core_js_map__WEBPACK_IMPORTED_MODULE_1___default())();
  const globalEffectsTeardownMap = new (_babel_runtime_corejs3_core_js_map__WEBPACK_IMPORTED_MODULE_1___default())();
  return {
    rootRegisterNode,
    activeBranchStack,
    rootRegister,
    activeBranchStackInitEffect,
    globalEffectsCounterMap,
    globalEffectsTeardownMap,
    ModalRegisterTreeContext,
    ModalPortalRefContext
  };
};
(_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2___default())[packageGlobals] = (_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2___default())[packageGlobals] || initGlobals();
const {
  rootRegister,
  rootRegisterNode,
  activeBranchStack,
  activeBranchStackInitEffect,
  globalEffectsCounterMap,
  globalEffectsTeardownMap,
  ModalRegisterTreeContext,
  ModalPortalRefContext
} = (_babel_runtime_corejs3_core_js_global_this__WEBPACK_IMPORTED_MODULE_2___default())[packageGlobals];

/***/ }),

/***/ 47470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(73591);

module.exports = parent;


/***/ }),

/***/ 17794:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(16399);

module.exports = parent;


/***/ }),

/***/ 23164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(39528);

module.exports = parent;


/***/ }),

/***/ 3468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(63999);

module.exports = parent;


/***/ }),

/***/ 82085:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(96307);

module.exports = parent;


/***/ }),

/***/ 37633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(47567);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').at;


/***/ }),

/***/ 14217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(81141);
__webpack_require__(34806);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').values;


/***/ }),

/***/ 39678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(81141);
__webpack_require__(55873);
__webpack_require__(34806);
__webpack_require__(67857);
var path = __webpack_require__(3999);

module.exports = path.Map;


/***/ }),

/***/ 42831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(81795);
var path = __webpack_require__(3999);

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;


/***/ }),

/***/ 87448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(85300);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('String').at;


/***/ }),

/***/ 17739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83415);


/***/ }),

/***/ 36503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22783);


/***/ }),

/***/ 11485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84027);


/***/ }),

/***/ 68971:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95609);


/***/ }),

/***/ 31394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1769);


/***/ }),

/***/ 28788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(47470);

// TODO: Remove from `core-js@4`
__webpack_require__(43223);

module.exports = parent;


/***/ }),

/***/ 83415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var arrayMethod = __webpack_require__(28788);
var stringMethod = __webpack_require__(2129);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.at;
  if (it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.at)) return arrayMethod;
  if (typeof it == 'string' || it === StringPrototype || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.at)) {
    return stringMethod;
  } return own;
};


/***/ }),

/***/ 84027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(17794);

module.exports = parent;


/***/ }),

/***/ 95609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(23164);
__webpack_require__(47309);
__webpack_require__(42406);
__webpack_require__(94295);
__webpack_require__(49672);
__webpack_require__(6413);
__webpack_require__(64969);
__webpack_require__(11530);
__webpack_require__(34451);
__webpack_require__(90952);
__webpack_require__(694);
__webpack_require__(22074);
__webpack_require__(36006);
__webpack_require__(84537);
__webpack_require__(45343);
__webpack_require__(28920);
__webpack_require__(12793);
__webpack_require__(55683);
__webpack_require__(62618);
// TODO: remove from `core-js@4`
__webpack_require__(35987);
// TODO: remove from `core-js@4`
__webpack_require__(85989);

module.exports = parent;


/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(3468);

module.exports = parent;


/***/ }),

/***/ 2129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(82085);
// TODO: Remove from `core-js@4`
__webpack_require__(29449);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('String').at;


/***/ }),

/***/ 53300:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var tryToString = __webpack_require__(4101);

// Perform ? RequireInternalSlot(M, [[MapData]])
module.exports = function (it) {
  if (typeof it == 'object' && 'size' in it && 'has' in it && 'get' in it && 'set' in it && 'delete' in it && 'entries' in it) return it;
  throw TypeError(tryToString(it) + ' is not a map');
};


/***/ }),

/***/ 27652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(39602);
var caller = __webpack_require__(71785);

var Map = getBuiltIn('Map');

module.exports = {
  Map: Map,
  set: caller('set', 2),
  get: caller('get', 1),
  has: caller('has', 1),
  remove: caller('delete', 1),
  proto: Map.prototype
};


/***/ }),

/***/ 36791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var iterateSimple = __webpack_require__(1735);

module.exports = function (map, fn, interruptible) {
  return interruptible ? iterateSimple(map.entries(), function (entry) {
    return fn(entry[1], entry[0]);
  }) : map.forEach(fn);
};


/***/ }),

/***/ 37900:
/***/ (function(module) {

// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
module.exports = function (x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y || x != x && y != y;
};


/***/ }),

/***/ 47567:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var toObject = __webpack_require__(77020);
var lengthOfArrayLike = __webpack_require__(48368);
var toIntegerOrInfinity = __webpack_require__(28955);
var addToUnscopables = __webpack_require__(86724);

// `Array.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
$({ target: 'Array', proto: true }, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : O[k];
  }
});

addToUnscopables('at');


/***/ }),

/***/ 67564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(50970);
var collectionStrong = __webpack_require__(94752);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 55873:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(67564);


/***/ }),

/***/ 81795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var DESCRIPTORS = __webpack_require__(14406);
var defineProperties = (__webpack_require__(66261).f);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ 85300:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var uncurryThis = __webpack_require__(21481);
var requireObjectCoercible = __webpack_require__(30849);
var toIntegerOrInfinity = __webpack_require__(28955);
var toString = __webpack_require__(80717);
var fails = __webpack_require__(19699);

var charAt = uncurryThis(''.charAt);

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
  return '𠮷'.at(-2) !== '\uD842';
});

// `String.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
$({ target: 'String', proto: true, forced: FORCED }, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : charAt(S, k);
  }
});


/***/ }),

/***/ 43223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(47567);


/***/ }),

/***/ 94295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aMap = __webpack_require__(53300);
var remove = (__webpack_require__(27652).remove);

// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  deleteAll: function deleteAll(/* ...elements */) {
    var collection = aMap(this);
    var allDeleted = true;
    var wasDeleted;
    for (var k = 0, len = arguments.length; k < len; k++) {
      wasDeleted = remove(collection, arguments[k]);
      allDeleted = allDeleted && wasDeleted;
    } return !!allDeleted;
  }
});


/***/ }),

/***/ 49672:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aMap = __webpack_require__(53300);
var MapHelpers = __webpack_require__(27652);

var get = MapHelpers.get;
var has = MapHelpers.has;
var set = MapHelpers.set;

// `Map.prototype.emplace` method
// https://github.com/tc39/proposal-upsert
$({ target: 'Map', proto: true, real: true, forced: true }, {
  emplace: function emplace(key, handler) {
    var map = aMap(this);
    var value, inserted;
    if (has(map, key)) {
      value = get(map, key);
      if ('update' in handler) {
        value = handler.update(value, key, map);
        set(map, key, value);
      } return value;
    }
    inserted = handler.insert(key, map);
    set(map, key, inserted);
    return inserted;
  }
});


/***/ }),

/***/ 6413:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  every: function every(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(map, function (value, key) {
      if (!boundFunction(value, key, map)) return false;
    }, true) !== false;
  }
});


/***/ }),

/***/ 64969:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var MapHelpers = __webpack_require__(27652);
var iterate = __webpack_require__(36791);

var Map = MapHelpers.Map;
var set = MapHelpers.set;

// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new Map();
    iterate(map, function (value, key) {
      if (boundFunction(value, key, map)) set(newMap, key, value);
    });
    return newMap;
  }
});


/***/ }),

/***/ 34451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  findKey: function findKey(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var result = iterate(map, function (value, key) {
      if (boundFunction(value, key, map)) return { key: key };
    }, true);
    return result && result.key;
  }
});


/***/ }),

/***/ 11530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  find: function find(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var result = iterate(map, function (value, key) {
      if (boundFunction(value, key, map)) return { value: value };
    }, true);
    return result && result.value;
  }
});


/***/ }),

/***/ 47309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var from = __webpack_require__(78129);

// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$({ target: 'Map', stat: true, forced: true }, {
  from: from
});


/***/ }),

/***/ 90952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var uncurryThis = __webpack_require__(21481);
var aCallable = __webpack_require__(23188);
var requireObjectCoercible = __webpack_require__(30849);
var iterate = __webpack_require__(67549);
var MapHelpers = __webpack_require__(27652);

var Map = MapHelpers.Map;
var has = MapHelpers.has;
var get = MapHelpers.get;
var set = MapHelpers.set;
var push = uncurryThis([].push);

// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$({ target: 'Map', stat: true, forced: true }, {
  groupBy: function groupBy(items, callbackfn) {
    requireObjectCoercible(items);
    aCallable(callbackfn);
    var map = new Map();
    var k = 0;
    iterate(items, function (value) {
      var key = callbackfn(value, k++);
      if (!has(map, key)) set(map, key, [value]);
      else push(get(map, key), value);
    });
    return map;
  }
});


/***/ }),

/***/ 694:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var sameValueZero = __webpack_require__(37900);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  includes: function includes(searchElement) {
    return iterate(aMap(this), function (value) {
      if (sameValueZero(value, searchElement)) return true;
    }, true) === true;
  }
});


/***/ }),

/***/ 22074:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var call = __webpack_require__(85837);
var iterate = __webpack_require__(67549);
var isCallable = __webpack_require__(64960);
var aCallable = __webpack_require__(23188);
var Map = (__webpack_require__(27652).Map);

// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', stat: true, forced: true }, {
  keyBy: function keyBy(iterable, keyDerivative) {
    var C = isCallable(this) ? this : Map;
    var newMap = new C();
    aCallable(keyDerivative);
    var setter = aCallable(newMap.set);
    iterate(iterable, function (element) {
      call(setter, newMap, keyDerivative(element), element);
    });
    return newMap;
  }
});


/***/ }),

/***/ 36006:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  keyOf: function keyOf(searchElement) {
    var result = iterate(aMap(this), function (value, key) {
      if (value === searchElement) return { key: key };
    }, true);
    return result && result.key;
  }
});


/***/ }),

/***/ 84537:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var MapHelpers = __webpack_require__(27652);
var iterate = __webpack_require__(36791);

var Map = MapHelpers.Map;
var set = MapHelpers.set;

// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new Map();
    iterate(map, function (value, key) {
      set(newMap, boundFunction(value, key, map), value);
    });
    return newMap;
  }
});


/***/ }),

/***/ 45343:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var MapHelpers = __webpack_require__(27652);
var iterate = __webpack_require__(36791);

var Map = MapHelpers.Map;
var set = MapHelpers.set;

// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  mapValues: function mapValues(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new Map();
    iterate(map, function (value, key) {
      set(newMap, key, boundFunction(value, key, map));
    });
    return newMap;
  }
});


/***/ }),

/***/ 28920:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(67549);
var set = (__webpack_require__(27652).set);

// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, arity: 1, forced: true }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  merge: function merge(iterable /* ...iterables */) {
    var map = aMap(this);
    var argumentsLength = arguments.length;
    var i = 0;
    while (i < argumentsLength) {
      iterate(arguments[i++], function (key, value) {
        set(map, key, value);
      }, { AS_ENTRIES: true });
    }
    return map;
  }
});


/***/ }),

/***/ 42406:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var of = __webpack_require__(75169);

// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$({ target: 'Map', stat: true, forced: true }, {
  of: of
});


/***/ }),

/***/ 12793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aCallable = __webpack_require__(23188);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

var $TypeError = TypeError;

// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var map = aMap(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aCallable(callbackfn);
    iterate(map, function (value, key) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, key, map);
      }
    });
    if (noInitial) throw $TypeError('Reduce of empty map with no initial value');
    return accumulator;
  }
});


/***/ }),

/***/ 55683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var bind = __webpack_require__(2733);
var aMap = __webpack_require__(53300);
var iterate = __webpack_require__(36791);

// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  some: function some(callbackfn /* , thisArg */) {
    var map = aMap(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(map, function (value, key) {
      if (boundFunction(value, key, map)) return true;
    }, true) === true;
  }
});


/***/ }),

/***/ 85989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: remove from `core-js@4`
var $ = __webpack_require__(37377);
var upsert = __webpack_require__(37575);

// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$({ target: 'Map', proto: true, real: true, name: 'upsert', forced: true }, {
  updateOrInsert: upsert
});


/***/ }),

/***/ 62618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var aCallable = __webpack_require__(23188);
var aMap = __webpack_require__(53300);
var MapHelpers = __webpack_require__(27652);

var $TypeError = TypeError;
var get = MapHelpers.get;
var has = MapHelpers.has;
var set = MapHelpers.set;

// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: true }, {
  update: function update(key, callback /* , thunk */) {
    var map = aMap(this);
    var length = arguments.length;
    aCallable(callback);
    var isPresentInMap = has(map, key);
    if (!isPresentInMap && length < 3) {
      throw $TypeError('Updating absent value');
    }
    var value = isPresentInMap ? get(map, key) : aCallable(length > 2 ? arguments[2] : undefined)(key, map);
    set(map, key, callback(value, key, map));
    return map;
  }
});


/***/ }),

/***/ 35987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: remove from `core-js@4`
var $ = __webpack_require__(37377);
var upsert = __webpack_require__(37575);

// `Map.prototype.upsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$({ target: 'Map', proto: true, real: true, forced: true }, {
  upsert: upsert
});


/***/ }),

/***/ 29449:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(37377);
var charAt = (__webpack_require__(19048).charAt);
var requireObjectCoercible = __webpack_require__(30849);
var toIntegerOrInfinity = __webpack_require__(28955);
var toString = __webpack_require__(80717);

// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$({ target: 'String', proto: true, forced: true }, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : charAt(S, k);
  }
});


/***/ }),

/***/ 73591:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(37633);

module.exports = parent;


/***/ }),

/***/ 41750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(14217);

module.exports = parent;


/***/ }),

/***/ 16399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(16490);
var classof = __webpack_require__(88531);
var hasOwn = __webpack_require__(42031);
var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(41750);

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.values;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.values)
    || hasOwn(DOMIterables, classof(it)) ? method : own;
};


/***/ }),

/***/ 39528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(39678);
__webpack_require__(16490);

module.exports = parent;


/***/ }),

/***/ 63999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(42831);

module.exports = parent;


/***/ }),

/***/ 96307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(87448);

module.exports = parent;


/***/ }),

/***/ 59321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17739);

/***/ }),

/***/ 75957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(36503);

/***/ }),

/***/ 17843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(11485);

/***/ }),

/***/ 12644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(68971);

/***/ }),

/***/ 26482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31394);

/***/ }),

/***/ 57621:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80719);

/***/ })

}]);